import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
//import SnGrid from "@shared/components/Grid/SnGrid";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnTabHeader from "@shared/components/SnTabHeader";
import { SnButton } from "@shared/components/SnButton";
import { showDialog } from "@widgets/CommonDialog";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";

interface popupProps {
  selectedDataList?: any;
  modalRef?: any;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_QMS_BAS_REG_002_POP_002 = forwardRef(
  ({ selectedDataList, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    //#endregion
    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [doubleData, setDoubleData] = useState<any[]>();
    const [popupParent, setPopupParent] = useState<any>(null);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedValue: async () => {
        return await onSave();
      },
      getSelectedRow: () => [
        gridRefs.current["grid1"].current.getSelectedRows() || [],
      ],
    }));

    useEffect(() => {
      if (doubleData) {
        modalRef.current?.handleConfirm(true);
      }
    }, [doubleData]);

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_QMS_BAS_REG_002_POP_002",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedDataList[0] };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_qms_bas_reg_002_pop_002",
            params: searchRef.current.getFormdata(),
          };

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0],
            grid2: data[1],
          });

          gridRefs.current["grid1"].current.selectAndFocusRow(0);
          gridRefs.current["grid1"].current.resetUpdate();
        } catch (error) {
          console.log(error);
        }
      };
      await fetchdatasource();
    };

    const onSave = async () => {
      try {
        gridRefs.current["grid1"].current?.stopEditing();
        gridRefs.current["grid2"].current?.stopEditing();
        // H 필수값 체크
        const requiredValuesCheckH =
          gridRefs.current["grid1"].current.requiredValuesCheck();
        if (!requiredValuesCheckH) {
          return;
        }

        // L 필수값 체크
        const requiredValuesCheckL =
          gridRefs.current["grid2"].current.requiredValuesCheck();
        if (!requiredValuesCheckL) {
          return;
        }

        const hChanges = gridRefs.current["grid1"].current.getChange();
        const lChanges = gridRefs.current["grid2"].current.getChange();
        const headerInserts = hChanges.insert ?? [];
        const lineInserts = lChanges.insert ?? [];
        if (headerInserts.length > 0 && lineInserts.length === 0) {
          await showDialog("alter", "저장에 실패했습니다.");
          return;
        }

        if (
          hChanges.modifiedRowcount === 0 &&
          lChanges.modifiedRowcount === 0
        ) {
          await showDialog("alter", "변경된 내용이 없습니다.");
          return;
        }
        const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
        gridRefs.current["grid2"].current.applyFilters({
          cd_sip: focusedNodeH.data?.cd_sip,
        });

        // 요청 데이터 구성
        const SaveData = {
          qms_siph: hChanges,
          qms_sipl: lChanges,
        };
        // 저장 API 호출
        const ok = await fnSave("SN_QMS_BAS_REG_002_POP_002_SAVE_01", SaveData);
        if (!ok) {
          return;
        }
        // 성공적으로 저장된 후 초기화
        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
      } catch (error: any) {
        gridRefs.current["grid1"].current.resetUpdate(true);
        gridRefs.current["grid2"].current.resetUpdate(true);
      }
    };

    const onAddRow = async () => {
      try {
        const searchInfo = searchRef.current.getFormdata();
        const newRow = {
          cd_firm: userInfo.cd_firm,
          cd_biz: searchInfo.cd_biz,
          fg_insp: searchInfo.fg_insp,
        }; // 빈 객체
        gridRefs.current["grid1"].current.addRow(newRow);
      } catch (error: any) {}
    };

    // const onBeforeAddRow = (newRow: RowData): boolean => {
    //   try {
    //     const salSohChanges = gridApiRefH.current.getChange().insert;
    //     if (salSohChanges.length > 0) return false;

    //     const updatedRow = {
    //       cd_firm: userInfo.cd_firm,
    //       cd_biz: selectedData.cd_biz,
    //       fg_insp: selectedData.fg_insp,
    //       cd_sip: "",
    //     };

    //     Object.assign(newRow, updatedRow); // 원본 객체 수정

    //     return true;
    //   } catch (error: any) {
    //     return false; // 추가 취소
    //   }
    // };

    const onAddRowL = async () => {
      try {
        gridRefs.current["grid1"].current?.stopEditing();
        const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
        if (focusedNodeH == null) {
          showDialog("alter", "선택된 행이 없습니다.");
          return false;
        }
        const requiredValuesCheckH =
          gridRefs.current["grid1"].current.requiredValuesCheck();
        if (!requiredValuesCheckH) {
          return false;
        }
        const maxNoLine =
          gridRefs.current["grid2"].current.getMaxValue("no_line");
        const newRow = {
          cd_firm: userInfo.cd_firm,
          no_line: maxNoLine + 1,
          cd_sip: focusedNodeH.data?.cd_sip,
        }; // 빈 객체
        gridRefs.current["grid2"].current?.addRow(newRow);
      } catch (error: any) {}
    };

    // const onBeforeAddRowL = (newRow: RowData): boolean => {
    //   try {
    //     // gridH가 선택되지 않았을 경우 리턴
    //     if (
    //       !gridApiRefH ||
    //       gridApiRefH.current.api.getSelectedNodes().length === 0
    //     ) {
    //       showDialog("alter", "선택된 행이 없습니다.");
    //       return false;
    //     }
    //     const requiredValuesCheckH = gridApiRefH.current.requiredValuesCheck();
    //     if (!requiredValuesCheckH) {
    //       return false;
    //     }

    //     const selectedRows = gridApiRefH.current.api.getSelectedNodes();
    //     const allRowData: any[] = [];
    //     gridApiRefL.current.api.forEachNode((node: any) => {
    //       allRowData.push(node.data);
    //     });

    //     const noLine = allRowData
    //       .filter((row: any) => row.cd_sip === selectedRows[0].data?.cd_sip)
    //       .map((row: any) => row.no_line || 0)
    //       .reduce((max, current) => Math.max(max, current), 0);

    //     const updatedRow = {
    //       cd_firm: userInfo.cd_firm,
    //       no_line: noLine + 1,
    //       cd_sip: selectedRows[0].data?.cd_sip,
    //     };

    //     Object.assign(newRow, updatedRow);

    //     return true;
    //   } catch (error: any) {
    //     return false;
    //   }
    // };

    const onDeleteRow = async () => {
      if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) {
        return;
      }

      const confirm = await showDialog("confirm", "삭제하시겠습니까?");

      if (!confirm) {
        return; // 사용자가 아니오를 선택하면 함수 종료
      }

      gridRefs.current["grid2"].current?.deleteAllRows();
      gridRefs.current["grid1"].current?.deleteSelectedRows();

      const realDeletedRows =
        gridRefs.current["grid1"].current.getChange().delete ?? [];
      if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
        // 실제로 삭제된 행이 없으면 변경 사항을 적용하고 반환합니다.
        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
        return;
      }
    };

    const onDeleteRowL = async () => {
      if (gridRefs.current["grid2"].current?.getDisplayedRowCount() < 1) {
        return;
      }
      gridRefs.current["grid2"].current?.deleteSelectedRows();
    };

    const onGridBtnsClick = async (id: string) => {
      if (id === "addRow") {
        onAddRow();
      } else if (id === "deleteRow") {
        onDeleteRow();
      }
    };

    const onGrid2BtnsClick = async (id: string) => {
      if (id === "addRow") {
        onAddRowL();
      } else if (id === "deleteRow") {
        onDeleteRowL();
      }
    };

    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event; // 클릭한 행 데이터
      if (selectedRow) {
        // 배열로 만들어서 필터링 함수 호출
        const cd_sip = selectedRow.cd_sip;
        gridRefs.current["grid2"].current.applyFilters({ cd_sip: cd_sip });
        gridRefs.current["grid2"].current.selectAndFocusRow(0);
      } else {
        return;
      }
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          />
        </div>

        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        {/* 그리드 영역을 가로로 배치 */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            height: "60vh",
          }}
        >
          {/* 왼쪽 그리드 */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <SnTabHeader
              onBtnAddClick={onGridBtnsClick}
              onBtnDeleteClick={onGridBtnsClick}
            />
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                isEditable: true,
                rowSelection: "single",
                popupParent: popupParent,
              }}
              events={grids.grid1.events}
              filter={{
                refs: [gridRefs.current["grid2"]],
                columns: ["cd_sip"],
              }}
            />
          </div>

          {/* 오른쪽 그리드 */}
          <div style={{ flex: 2, display: "flex", flexDirection: "column" }}>
            <SnTabHeader
              onBtnAddClick={onGrid2BtnsClick}
              onBtnDeleteClick={onGrid2BtnsClick}
            />
            <SnGrid
              ref={gridRefs.current["grid2"]}
              columnConfig={grids.grid2.columns}
              rowData={grids.grid2.dataSource}
              etcProps={{
                isEditable: true,
                rowSelection: "single",
                popupParent: popupParent,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_QMS_BAS_REG_002_POP_002;
